import { https } from './api'

export default class {
    constructor() {
        this.instance = https('/academicmovements')
    }

    getCoursesByRA = (ra) => {
        return this.instance({
            method: 'GET',
            url: `/courses/${ra}`
        });
    }

    getDisciplines = (ra, qualificationId, schoolYearId) => {
        return this.instance({
            method: 'GET',
            url: `/disciplines/${ra}/${qualificationId}/${schoolYearId}`
        });
    }

    getMovementReasons = (courseTypeId) => {
        return this.instance({
            method: 'GET',
            url: `/reasons/${courseTypeId}`
        });
    }

    getDestinationOptions = (subjectId, qualificationId, exclusiveLicense) => {
        return this.instance({
            method: 'GET',
            url: `disciplines/destinationoptions/${qualificationId}/${subjectId}/${exclusiveLicense}`
        });
    }

    executeTransferProcess = (data) => {
        return this.instance({
          method: "POST",
          url: `academicTransfer`,
          timeout: 240000,
          data,
        })
      }

    getStudentsBySubjectId = (subjectId) => {
        return this.instance({
            method:"GET",
            url: `students/${subjectId}`,
            timeout: 240000,
        })
    }

    getOffer = (ra, qualificationId, sameBranchAndShift) => {
        return this.instance({
            method: "GET",
            url: `offer/${ra}/${qualificationId}/${sameBranchAndShift}`,
            timeout: 240000,
        })
    }
}
